/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError } from '.';
import CommonApi from '../Api/CommonApi';
import ClientApi from '../Api/ClientApi';

export const fetchStates = createAsyncThunk(
  'FETCH_STATES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getStates();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchUserLevels = createAsyncThunk(
  'FETCH_USER_LEVELS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getUserLevels();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchPageTypes = createAsyncThunk(
  'FETCH_PAGE_TYPES',
  async (_, thunkApi) => {
    // const { pageTypes } = useAppSelector((state))
    try {
      const response = await CommonApi.getPageTypes();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchIndustries = createAsyncThunk(
  'FETCH_INDUSTRIES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getIndustries();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchFileTypes = createAsyncThunk(
  'FETCH_FILETYPES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getFileTypes();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchSubscriptions = createAsyncThunk(
  'FETCH_SUBSCRIPTIONS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getSubscriptions();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchCustomOptions = createAsyncThunk(
  'FETCH_CUSTOMOPTIONS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getCustomOptions();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchExistingEmails = createAsyncThunk(
  'FETCH_EXISTINGEMAILS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getExistingEmails();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);


export const fetchCategories = createAsyncThunk(
  'FETCH_CATEGORIES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getCategories();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchSubCategories = createAsyncThunk(
  'FETCH_SUBCATEGORIES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getSubCategories();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchEquipmentSearchData = createAsyncThunk(
  'FETCH_EQUIPMENTSEARCHDATA',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getEquipmentSearchData();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchClients = createAsyncThunk(
  'FETCH_CLIENTS',
  async (_, thunkApi) => {
    try {
      const response = await ClientApi.getClientsList();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchEquipmentListCustom = createAsyncThunk(
  'FETCH_EQUIPMENT_LIST_CUSTOM',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getEquipmentListCustom();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchTerritoryList = createAsyncThunk(
  'FETCH_TERRITORY_LIST',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getTerritoryList();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
